







import {Component, Prop, Vue} from "vue-property-decorator";
import CounterpartyDTO from "@/dto/company/CounterpartyDTO";
import {namespace} from "vuex-class";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import CounterpartyService from "@/services/CounterpartyService";
import ErrorLocalePathUtils from "@/utils/ErrorLocalePathUtils";
import ProspectiveCounterpartyDTO from "@/dto/company/ProspectiveCounterpartyDTO";
import EmploymentSearch from "@/components/common/EmploymentSearch.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import {OptionsBuilder} from "@/components/common/SelectOption";
import {IEmployment} from "@/dto/payroll/IEmployment";
import {IForeignContractor} from "@/components/payroll/business/employments/foreignContractors/ForeignContractorPayloads";
import RouteNames from "@/router/RouteNames";

const AppModule = namespace("App");


@Component({
  computed: {
    OB() {
      return OptionsBuilder
    }
  },
  components: {PortalSelect, EmploymentSearch, PaginationComponent}
})
export default class SelectCounterpartyModal extends Vue {

  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  private message = "";

  private successful = true;

  private contractorType: 'BUSINESS_FOREIGN_CONTRACTOR' | 'INDIVIDUAL_FOREIGN_CONTRACTOR' | null = null;

  @Prop()
  private filter!: { companyId: number };

  select(contractor: IEmployment): void {
    this.$router.push({
      name: RouteNames.PAYROLL_BUSINESS_FORMS_1042S,
      params: {
        'companyId': `${this.filter.companyId}`,
        'contractorId': `${contractor.id}`,
        'counterpartyType': `${this.counterpartyType}`
      }
    });
    this.$modal.hideAll();
  }

  get counterpartyType(): 'PERSON' | 'COMPANY' {
    switch (this.contractorType) {
      case 'BUSINESS_FOREIGN_CONTRACTOR': return 'COMPANY';
      case 'INDIVIDUAL_FOREIGN_CONTRACTOR': return 'PERSON';
      default: throw new Error('Unknown contractor type');
    }
  }

}
